import React from 'react';

import Tabs, { IProps as ITabsProps } from '@/components/switchback/Tabs/Tabs';

import css from './FilterTabs.module.css';

export const FilterTabs: React.FC<ITabsProps> = props => {
  return <Tabs {...props} className={css.root} />;
};
